import { dcDataStoreItem } from '../datastore-item.model';

export class RequestStatus {
  constructor(
    public RequestID: string,
    public ResponseStatus: ResponseStatus,
    public SentDateTime: Date = new Date(),
    public ReceivedDateTime?: Date,
    public DataStoreItems?: dcDataStoreItem[],
    public Count: number = 0
  ) {}
}

export enum ResponseStatus {
  New,
  Pending,
  SavingInDB,
  PendingDataFromApi,
  ExistingDataAdded,
  FullDataReceived,
  KeysReceived,
  AttributesReceived,
  Done,
  OnAllDataReceived,
  ConsolidatedDataReceived,
  onComponentDataAsJSONReceived,
  StackCrawlerReceived,
  LookupDataReceived,
  ExceptionReceived
}
